import { Alert, AlertColor } from '@mui/material';
import { FC } from 'react';
import { IToastifyComponent } from './types';
// ==========================================:
const ToastifyComponent: FC<IToastifyComponent> = ({ message, toastProps }) => {
	return (
		<Alert
			variant="filled"
			severity={(toastProps?.type ?? 'info') as AlertColor}
			sx={{
				width: '100%',
				height: 'auto',
				minHeight: '64px',
				whiteSpace: 'pre-wrap',
				wordBreak: 'break-word',
				overflow: 'visible',
				display: 'flex',
				alignItems: 'flex-start',
				'& .MuiAlert-message': {
					width: '100%',
					overflow: 'visible',
					padding: '8px 0',
				},
			}}
		>
			{message}
		</Alert>
	);
};

export default ToastifyComponent;
